module.exports = __webpack_public_path__ + "assets/images/slope-aging/tablet.svg?v=e704c976";